import { useStockClassSchema } from "components/api/useStockClassSchema";

export const useStockClassDisplayName = (type, stockClass) => {
  const stockClassSchema = useStockClassSchema();
  // type: one of ['dairy', 'beef', 'sheep']
  return stockClassSchema?.[type]?.find((schema) => schema.value === stockClass)
    .display_name;
};
